const isIE11 = () => !!window.MSInputMethodContext && !!document.documentMode;
const isEdge = () => navigator.userAgent.indexOf('Edge') >= 0;
const isMSBrowser = [isIE11, isEdge].some(f => f());

const eiScroll = (envElement, params) => envElement.scroll(0, params.top);
const bestScrollEver = (envElement, params) => envElement.scroll({
  left: params.left,
  top: params.top,
  behavior: 'smooth',
});

export default (scrollOnMount = true) => ({
  computed: {
    anchor() {
      return this.$route.hash;
    },
  },
  methods: {
    additionalTopOffset(current) {
      const topFixedElement = document.querySelector('#fixed-header');
      if (topFixedElement) {
        return current - topFixedElement.offsetHeight;
      }
      return current;
    },
    goToAnchor(anchor, updateHash = true, envEl = false) {
      const [root, envElement] = [envEl || document, envEl || window];
      const el = root.querySelector(`${anchor}`);
      if (el) {
        if (updateHash) {
          this.$router.push({ hash: anchor });
        }
        this.$nextTick(() => {
          const params = {
            left: 0,
            top: this.additionalTopOffset(el.offsetTop),
          };
          if (isMSBrowser) {
            eiScroll(envElement, params);
          } else {
            bestScrollEver(envElement, params);
          }
        });
      }
    },
    goToEnv(selector, evn = false, updateHash = false) {
      const envElement = document.querySelector(evn);
      this.goToAnchor(selector, updateHash, envElement);
    },
  },
  mounted() {
    if (scrollOnMount && this.anchor) {
      this.$nextTick(() => this.goToAnchor(this.anchor));
    }
  },
});



// WEBPACK FOOTER //
// ./src/mixins/anchorScroll.js